module.exports = __webpack_public_path__ + "img/56.3ca90b8c.jpg";